module.exports = __webpack_public_path__ + "img/isfp.9dd2457a.png";